(() => {
  if (customElements.get('miramar-cart-consent')) return;
  class MiramarCartConsent extends HTMLElement {
    connectedCallback() {
      this.checkbox = this.querySelector('input[type="checkbox"]');
      if (!this.checkbox) return;
      // Consent is explicit for this cart view, never preselected or restored.
      this.checkbox.checked = false;
      this.onChange = () => this.sync();
      this.checkbox.addEventListener('change', this.onChange);
      this.sync();
    }
    disconnectedCallback() {
      this.checkbox?.removeEventListener('change', this.onChange);
    }
    sync() {
      const accepted = this.checkbox.checked && this.dataset.empty !== 'true';
      this.dataset.accepted = String(accepted);
      document.querySelectorAll('button[name="checkout"]').forEach(button => {
        if (button.form?.id !== this.dataset.form) return;
        button.disabled = !accepted;
        button.dataset.consentLocked = String(!accepted);
      });
    }
  }
  customElements.define('miramar-cart-consent', MiramarCartConsent);

  const consentFor = form => [...document.querySelectorAll('miramar-cart-consent')]
    .find(consent => consent.dataset.form === form?.id);
  const block = (event, consent) => {
    event.preventDefault();
    event.stopImmediatePropagation();
    consent?.checkbox?.focus();
  };
  // Guard both clicks and keyboard submits, including forms with novalidate.
  document.addEventListener('click', event => {
    const button = event.target.closest?.('button[name="checkout"]');
    if (!button) return;
    const consent = consentFor(button.form);
    if (!consent?.checkbox?.checked || consent.dataset.empty === 'true') block(event, consent);
  }, true);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!['cart', 'CartDrawer-Form'].includes(form.id)) return;
    if (event.submitter && event.submitter.name !== 'checkout') return;
    const consent = consentFor(form);
    if (!consent?.checkbox?.checked || consent.dataset.empty === 'true') block(event, consent);
  }, true);
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('miramar-cart-consent').forEach(consent => {
      if (!consent.checkbox) return;
      consent.checkbox.checked = false;
      consent.sync();
    });
  });
})();
